'use client';

import dynamic from 'next/dynamic';

const ClientServerGraph = dynamic(
  () => import('./ClientServerGraph')
);

export default ClientServerGraph;
